<script lang="ts">
    import List from '$lib/components/_DisplayComponents/List/List.svelte';
    import { DEFAULT_LAYOUT } from '$lib/components/constants';
    import { getColor, personalizeText } from '$lib/helper';

    // Types
    import type { Theme, TransitionEffect } from '$lib/types/Theme';
    import type { TrackingProperty } from '$lib/types/TrackingProperty';
    import type { Component } from '$lib/types/Components/SharedTypes';
    import type { Language } from '$lib/types/Language';
    import type { ListContent } from '$lib/types/Components/List/ListContent';
    import type { ListItemProps } from '$lib/types/Components/List/ListItemProps';

    export let childComponents: Component[] = [];
    export let content: ListContent;
    export let theme: Theme;
    export let transitionDelay = 0;
    export let transitionEffect: TransitionEffect = 'none';
    export let campaignId = '';
    export let trackingProperties: TrackingProperty[] = [];
    export let language: Language = 'de';
    export let layout = DEFAULT_LAYOUT;

    const listItems: ListItemProps[] = childComponents
        .filter((listItem) => {
            // TODO CF: fix it on editor side instead of filtering it here
            return listItem.components[0] && listItem.components[1];
        })
        .map((listItem) => {
            const media = listItem.components[0];
            const text = listItem.components[1];

            return {
                align: content.align,
                color: getColor(text.content.color, theme.fontColor),
                draft: personalizeText(
                    text.content.wysiwyg,
                    trackingProperties,
                    campaignId,
                    language,
                ),
                emoji: media.content.emoji,
                imageSrc: media.content.src,
                mediaType: media.content.srcType,
                cornerRounding: content.borderRadius,
                linkColor: theme.buttonBackgroundColor,
            };
        });
</script>

<svelte:component
    this={List}
    box={content.box}
    align={content.align}
    textSize={content.textSize}
    visualSize={content.visualSize}
    {listItems}
    {transitionDelay}
    {transitionEffect}
    {layout}
/>
